import { TICKET_PRIORITY_LABELS, UNTRIAGED_LABEL, type TicketPriority } from '@easyhelp/shared';
import Chip from '@mui/material/Chip';

/** Fondo e testo di un livello, come chiavi della palette del tema di `@easydoctor/ui`. */
export interface PriorityTone {
  bgcolor: string;
  color: string;
}

/**
 * Un colore per livello (#118): Urgente rosso, Alta arancio, Media azzurro (`info`), Bassa grigio.
 * Ogni coppia ha contrasto almeno 4.5:1 sui valori del tema (lo verifica `PriorityChip.test.tsx`).
 * Le usano il chip e il pulsante scelto in «Imposta la priorità», così i colori restano gli stessi.
 */
export const PRIORITY_TONES: Record<TicketPriority, PriorityTone> = {
  urgente: { bgcolor: 'error.light', color: 'error.darker' },
  alta: { bgcolor: 'warning.lighter', color: 'warning.dark' },
  media: { bgcolor: 'info.lighter', color: 'info.dark' },
  bassa: { bgcolor: 'grey.200', color: 'grey.800' },
};

/** «Da triare»: solo bordo e testo arancio su fondo bianco, nessun fondo pieno. */
export const UNTRIAGED_TONE = { borderColor: 'warning.main', color: 'warning.dark', bgcolor: 'common.white' };

/**
 * Priorità del ticket (PRD-004 US-2). Senza priorità è «Da triare», **visivamente distinto**:
 * bordo e testo arancio su fondo bianco, invece del chip pieno dei livelli assegnati.
 */
export function PriorityChip({ priority }: { priority: TicketPriority | null }) {
  if (priority === null) {
    return <Chip size="small" variant="outlined" label={UNTRIAGED_LABEL} sx={UNTRIAGED_TONE} />;
  }
  return <Chip size="small" label={TICKET_PRIORITY_LABELS[priority]} sx={PRIORITY_TONES[priority]} />;
}
